import { MaybeArray } from "./types"

export default function ensureArray<T>(value: MaybeArray<T>): T[] {
    return Array.isArray(value) ? value : [value]
}
